<template>
    <div v-if="isShow" class="consult-dialog">
        <div class="dialog-mask" @click="onHiddenDialog"></div>
        <div class="dialog-main">
            <div class="dialog-title">
                <span class="specity-text-color">一键提交需求</span>
                <span>专业顾问接待</span>
            </div>
            <div class="dialog-form">
                <div class="form-item">
                    <div class="form-item-label">
                        您想咨询的服务项目：
                    </div>
                    <div class="form-item-checkbox">
                        <button
                            v-for="(item, index) in bizTypeSource"
                            :key="index"
                            :class="{active: formData.bizType === item.value}"
                            @click="onChangebizType(item.value)"
                        >{{ item.text }}</button>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-item-label">
                        电话：
                        <span class="is-required">*</span>
                    </div>
                    <input
                        v-model="formData.phone"
                        :class="{'input-error': !!errorObj.phone}"
                        placeholder="请输入手机号"
                        type="number"
                    />
                    <p v-show="errorObj.phone" class="error-text">{{ errorObj.phone }}</p>
                </div>
                <div class="form-item">
                    <div class="form-item-label">
                        验证码：
                        <span class="is-required">*</span>
                    </div>
                    <div class="form-item-content">
                        <input
                            v-model="formData.smsCode"
                            :class="{'input-error': !!errorObj.smsCode}"
                            placeholder="请输入验证码"
                            type="number"
                        />
                        <button class="code-btn" @click="getVerifyCode">
                            {{ codeCountDown === 60 ? '发送验证码' : `${codeCountDown}s` }}
                        </button>
                    </div>
                    <p v-show="errorObj.smsCode" class="error-text">{{ errorObj.smsCode }}</p>
                </div>
                <div class="form-item">
                    <div class="form-item-label">
                        需求：
                    </div>
                    <input
                        class="form-item-input"
                        placeholder="请描述您的需求或疑问"
                        v-model="formData.description"
                        maxlength="1024"
                    />
                    <p v-show="errorObj.description" class="error-text">{{ errorObj.description }}</p>
                </div>
                <div class="form-item-agreement">
                    <span
                        :class="{'form-item-radius': true, 'agreed': isAgree}"
                        @click="isAgree = !isAgree"
                    ></span>
                    <span>勾选表示同意</span>
                    <a href="https://cloud.baidu.com/doc/Agreements/s/Kjwvy245m">
                        《百度智能云用户隐私协议》
                    </a>
                </div>
            </div>
            <button
                :class="{'dialog-confirm': true, disable: !isAgree}"
                @click="onConfirm"
            >
                立即提交
            </button>
        </div>
    </div>
</template>

<script>

import {Message} from 'element-ui';
import {formDataValidConfig} from '../../pages/data/global';
import client from '../../common/client';
import {isLogin} from '../../util/helper';
import {sendCodeMixin} from './mixin';

export default {
    mixins: [sendCodeMixin],

    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        bizType: {
            type: String,
            default: 'CRS'
        }
    },

    data() {
        const bizType = this.bizType;
        return {
            bizTypeSource: [
                {text: '工商注册', value: 'COMREG'},
                {text: '财税服务', value: 'BKP'},
                {text: '资质代办', value: 'BLA'}
            ],
            formData: {
                area: '110100',
                bizType,
                description: '',
                hasLogin: false,
                phone: '',
                smsCode: ''
            },
            isAgree: true,
            isSendCode: false,
            errorObj: {}
        };
    },

    mounted() {
        isLogin()
            .then(res => {
                this.formData.hasLogin = res && res.result && res.result.hasLogin;
            })
            .catch(() => {
                this.formData.hasLogin = false;
            });
    },

    methods: {
        onHiddenDialog() {
            this.$emit('onHide', false);
        },

        onChangebizType(value) {
            this.formData.bizType = value;
        },

        validorFormData(list = ['phone', 'smsCode', 'description']) {
            let isPass = true;
            list.map(key => {
                const value = this.formData[key];
                this.$set(this.errorObj, key, formDataValidConfig[key](value) || '');
                if (this.errorObj[key]) {
                    isPass = false;
                }
            });
            return isPass;
        },

        getVerifyCode() {
            if (!this.validorFormData(['phone'])) {
                return;
            }
            this.getVerifyCodeMixin(this.formData.phone);
        },

        onConfirm() {
            if (!this.validorFormData()) {
                return;
            }
            const formData = this.formData;
            client.submitBkpDemand(formData).then(res => {
                if (res.data && res.data.success === false) {
                    Message({
                        type: 'error',
                        message: '提交失败',
                        offset: 60
                    });
                    return;
                }
                Message({
                    type: 'success',
                    message: '提交成功',
                    offset: 60
                });
                this.$emit('onHide', false);
            });
        }
    }
};
</script>

<style lang="less" scoped>
.consult-dialog {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 777;

    input {
        color: #1b1e3f;
        transition: 0.3s all;
        border: 0.1rem solid #E1E6F0;
        border-radius: 0.4rem;
        background: #fff;
        outline: none;
        font-family: PingFangSC-Regular;
        font-size: 2.6rem;
        letter-spacing: 0;
        font-weight: 400;
        display: block;
        width: 100%;
        height: 6.8rem;
        padding: 0 2rem;
        box-sizing: border-box;
        &::placeholder {
            opacity: 0.5;
        }
        &:focus {
            border-color:#2a62fe;
        }
        &.input-error {
            border-color:#f34f4f;
        }
    }

    .dialog-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.2);
    }

    .dialog-main {
        width: 64rem;
        max-width: 350px;
        height: auto;
        background-color: #fff;
        border-radius: 1rem;
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 77;
        padding: 4rem 3rem;
        box-sizing: border-box;
        transition: 0.3s all;
        animation: enter_scale 0.3s ease-in-out forwards;
    }

    .dialog-title {
        text-align: center;
        span {
            font-family: PingFangSC-Medium;
            font-size: 3.2rem;
            color: #1B1E3F;
            letter-spacing: 0;
            text-align: center;
            font-weight: 500;
            margin: 0 1rem;
        }
        .specity-text-color {
            color: #F27054;
        }
    }

    .dialog-form {
        .form-item-label {
            font-family: PingFangSC-Regular;
            font-size: 2.8rem;
            color: #1B1E3F;
            letter-spacing: 0;
            font-weight: 400;
            margin: 2.8rem 0 2rem 0;
        }
        .form-item-checkbox {
            display: flex;
            justify-content: space-between;
            button {
                padding: 1.2rem 3.8rem;
                border: 0.1rem solid #2A62FE;
                border-radius: 0.4rem;
                font-family: PingFangSC-Regular;
                font-size: 2.6rem;
                color: #2A62FE;
                letter-spacing: 0;
                font-weight: 400;
                background: #fff;
                transition: 0.3s all;
            }
            button.active {
                color: #fff;
                background: #2A62FE;
            }
        }
        .form-item-agreement {
            margin: 2rem 0 3rem 0;
            a {
                color: #2A62FE;
                text-decoration: none;
            }
        }
        .form-item-content {
            display: flex;
            justify-content: space-between;
        }
        .code-btn {
            width: 20rem;
            height: 6.8rem;
            background: #2a62fe;
            border-radius: 0.4rem;
            font-family: PingFangSC-Regular;
            font-size: 2.6rem;
            color: #fff;
            letter-spacing: 0;
            font-weight: 400;
            border: none;
            outline: none;
            white-space: nowrap;
        }
    }

    .dialog-confirm {
        width: 100%;
        padding: 2rem 0;
        display: block;
        background: #2A62FE;
        border-radius: 1rem;
        font-family: PingFangSC-Regular;
        font-size: 2.8rem;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
        border: none;
        outline: none;
        transition: 0.3s all;
        &.disable {
            background: #dcdfe6;
            border-radius: 0.4rem;
            color: #fff;
            cursor: no-drop;
        }
    }

    .form-item-radius {
        display: inline-block;
        width: 2.6rem;
        height: 2.6rem;
        opacity: 0.3;
        border: 0.1rem solid #1B1E3F;
        border-radius: 50%;
        margin-right: 2rem;
        vertical-align: middle;
    }

    .form-item-radius.agreed {
        background-image: url(../../assets/mobile/cbs/gou2.png);
        background-size: 100% 100%;
        opacity: 1;
        border: none;
    }

    .error-text {
        color: #f34f4f;
        font-size: 2rem;
    }

    .is-required {
        opacity: 0.8;
        font-family: PingFangSC-Regular;
        font-size: 2.8rem;
        color: #F02323;
        letter-spacing: 0;
        font-weight: 400;
    }
}

@keyframes enter_scale {
    0% {
        transform: scale(0) translate(-50%, -50%);
    }
    100% {
        transform: scale(1) translate(-50%, -50%);
    }
}
</style>